"use client";

export default function Gallery() {
  // Gallery images data
  const galleryImages = [
    {
      src: "https://storage.googleapis.com/wbf-static/storage/vs37j5S/b6a97045c3216704da2bc4ec38e529e4.jpg",
    },
    {
      src: "https://storage.googleapis.com/wbf-static/storage/vs37j5S/4ed7f5b8d836f9b575bf7936dcfdae0b.jpg",
    },
    {
      src: "https://storage.googleapis.com/wbf-static/storage/vs37j5S/bb14ceacaf2e21c8d31868ae9dd1089a.png",
    },
  ];

  return (
    <section
      id="gallery"
      className="relative z-10 overflow-hidden py-12 lg:py-[4.5rem] w-full rounded-t-3xl"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 lg:px-0">
        <div className="flex flex-col items-center gap-12 lg:flex-row lg:justify-between lg:items-stretch">
          {/* Content Section */}
          <div className="flex w-full flex-col items-start text-left lg:max-w-[20rem]">
            <span className="text-sm uppercase tracking-wider text-primary mb-2">
              Our Projects
            </span>
            <h2 className="text-3xl font-bold text-foreground mb-4">
              Quality is our number one priority
            </h2>

            {/* Text with decorative background */}
            <div className="relative mb-4">
              <p className="text-foreground/60 mb-8">
                Discover the quality and variety of construction projects
                completed by Bishop Mercier in Westmount and beyond.
              </p>
              {/* Decorative background rectangle */}
              <div className="hidden lg:block absolute bottom-0 left-0 -z-10 h-4/5 w-full bg-primary/10 lg:h-[100vw] lg:w-[250vw] lg:-translate-x-1/2 lg:left-1/2 rounded-t-[20rem]" />
            </div>

            {/* CTA Button */}
            <a
              href="/portfolio"
              className="w-fit flex justify-center items-center relative rounded-md bg-primary text-primary-foreground px-8 py-4 font-bold transition-all hover:bg-primary/90"
            >
              <span className="lg:text-[1.15rem]">Check our Portfolio</span>
            </a>
          </div>

          {/* Gallery Grid */}
          <div className="grid w-full grid-cols-3 gap-4 lg:order-none -order-1">
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="relative aspect-square w-full lg:min-h-[20rem]"
              >
                <img
                  src={image.src}
                  className="h-full w-full object-cover rounded-sm"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
